import * as React from 'react';

const ChevronUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 10.414L7.707 14.707C7.317 15.097 6.683 15.097 6.293 14.707C5.903 14.317 5.903 13.683 6.293 13.293L11.293 8.293C11.683 7.903 12.317 7.903 12.707 8.293L17.707 13.293C18.097 13.683 18.097 14.317 17.707 14.707C17.317 15.097 16.683 15.097 16.293 14.707L12 10.414Z" fill="currentColor"/>
  </svg>
);

export default ChevronUp;
